import React from 'react';

import { classnames, margin, padding, useClassnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import { KeyboardKey } from '@lumapps/lumx-shortcuts/components/KeyboardKey';
import { mdiMagnify } from '@lumapps/lumx/icons';
import { Chip, Emphasis, FlexBox, IconButton, Orientation, Size, type Theme } from '@lumapps/lumx/react';
import { GLOBAL, useTranslate } from '@lumapps/translations';
import { formatShortcut } from '@lumapps/utils/string/formatShortcut';

import './index.scss';

interface SpotlightFakeSearchProps {
    buttonRef?: React.RefObject<HTMLAnchorElement>;
    onClick: () => void;
    scope: string;
    theme?: Theme;
}

const CLASSNAME = 'lumx-spotlight-fake-search';

export const SpotlightFakeSearch: React.FC<SpotlightFakeSearchProps> = ({
    buttonRef,
    onClick,
    scope,
    theme = 'light',
}) => {
    const { translateKey } = useTranslate();
    const { get } = useDataAttributes(scope);
    const { element } = useClassnames(CLASSNAME);

    return (
        <FlexBox orientation={Orientation.horizontal} className={margin('top', Size.huge)}>
            <Chip
                after={
                    <KeyboardKey
                        keyboardKey={formatShortcut(true, 'K')}
                        className={classnames(padding('vertical', Size.tiny), padding('horizontal'))}
                    />
                }
                className={element('chip', { [theme]: true })}
                onClick={onClick}
                ref={buttonRef}
                theme={theme}
                {...get({ element: 'button', action: 'search' })}
            >
                {translateKey(GLOBAL.SEARCH)}
            </Chip>
            <IconButton
                className={element('icon', { [theme]: true }, [padding('horizontal')])}
                emphasis={Emphasis.medium}
                icon={mdiMagnify}
                label={translateKey(GLOBAL.SEARCH)}
                theme={theme}
                onClick={onClick}
                {...get({ element: 'button', action: 'search' })}
            />
        </FlexBox>
    );
};
